import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet'
import { resetPw } from '../../resources/images'
import * as UIActions from '../../actions/uiAction';
import { TextField } from '@material-ui/core';

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: {
                value: '',
                invalidField: null
            },
            emailSent: false
        }
    }

    handleInput = (target) => {
        const id = target.id
        const value = target.value

        this.setState({
            [id]: {
                ...this.state[id],
                value
            }
        })
    }

    runValidation = (target) => {
        const { email } = this.state
        const id = target ? target.id : null
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        let invalidField = false
        let errMsg = ''

        switch (id) {
            case "email": {
                if (email.value.length && !emailRegex.test(email.value)) {
                    invalidField = true
                    errMsg = "Please enter a valid email"
                    break
                } else break
            }
            default: {
                if (!email.value.length) {
                    return false
                } else if (email.invalidField || email.invalidField === null) {
                    this.setState({
                        email: {
                            ...this.state.email,
                            invalidField: true
                        }
                    })
                    this.props.addError('Please make sure all the field above is correct')
                    return false
                } else return true
            }
        }

        if (id) {
            this.setState({
                [id]: {
                    ...this.state[id],
                    invalidField,
                    errMsg
                }
            })
        }
    }

    onSubmit = () => {
        const { emailSent, email } = this.state

        if (!emailSent) {
            if (this.runValidation()) {
                this.props.showSuccess(`Reset email has been sent to ${email.value}`)
                this.setState({ emailSent: true })
            }
        } else {
            this.props.history.push('/')
        }
    }

    render() {
        const { email, emailSent } = this.state
        const verified = email.invalidField === false && email.value.length
        return (
            <Fragment>
                <Helmet>
                    <title>QBank Forgot Password Page</title>
                    <meta name="description" content="QBank Forgot Password Page allowed existing user to reset their user account with their user email." />
                </Helmet>
                <div className="forgotPwdPage">
                    {!emailSent ?
                        <div className="qbCard init">
                            <div className="fTitle">Create or Reset Password</div>
                            <div className="fBody">Provide your email address below, and we'll send instructions on how to set your password.</div>
                            <div className="qbForm">
                                <div className="itemCont">
                                    <TextField
                                        id="email"
                                        label="Email"
                                        style={{ width: '100%', marginTop: 15, marginBottom: 25, minHeight: 70 }}
                                        error={email.invalidField}
                                        helperText={email.invalidField && email.errMsg}
                                        defaultValue={email.value}
                                        InputProps={{
                                            style: { fontSize: 15 }
                                        }}
                                        InputLabelProps={{
                                            style: { fontSize: 15, color: 'rgba(0, 0, 0, 0.25)' }
                                        }}
                                        FormHelperTextProps={{
                                            style: { fontSize: 13 }
                                        }}
                                        onBlur={(e) => this.runValidation(e.target)}
                                        onChange={(e) => this.handleInput(e.target)}
                                    />
                                </div>
                            </div>
                            <div className="actionCont">
                                <div className={verified ? "qbBtn active": "qbBtn"} onClick={() => this.onSubmit()}>SUBMIT</div>
                            </div>
                        </div>
                        : <div className="qbCard">
                            <img src={resetPw} alt="" className="qbImg" />
                            <div className="fTitle" style={{ textAlign: 'center' }}>MISSION ACCOMPLISHED!</div>
                            <div className="fBody" style={{ textAlign: 'center' }}>Success! Check your email - or spam - to log in and get started.</div>
                            <div className="actionCont active">
                                <div className="qbBtn" onClick={() => this.onSubmit()}>I'M DONE</div>
                            </div>
                        </div>
                    }
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ }) => ({
});

const mapDispatchToProps = (dispatch) => ({
    addError: (msg) => dispatch(UIActions.addError(msg)),
    showSuccess: (msg) => dispatch(UIActions.showSuccess(msg)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotPassword));


// WEBPACK FOOTER //
// ./src/Components/forgotPassword/ForgotPassword.js